// Typed field values are stored per block so two cards that share a field name
// (e.g. height in "Build disclosed on app" and "Build in APS") don't overwrite
// each other. The prefix is separate from `__field_removed_` on purpose.
export const blockValuePrefix = (blockId: string): string =>
  `__value_${blockId}_`;

export const blockValueKey = (blockId: string, key: string): string =>
  `${blockValuePrefix(blockId)}${key}`;

// Block-scoped value first, then the plain key. The plain key is what the
// legacy modal passes (one source, flat values), so those letters keep working.
export function readFieldValue(
  fieldValues: Record<string, string>,
  key: string,
  blockId?: string,
): string | undefined {
  if (blockId !== undefined) {
    const scoped = fieldValues[blockValueKey(blockId, key)];
    if (scoped !== undefined) return scoped;
  }
  return fieldValues[key];
}
